import React from 'react';

import Icon, { Props } from './icon';

export const ExtendIcon: React.FC<Props> = (props) => {
  return (
    <Icon {...props} viewBox="0 0 33.3334 33.3334">
      <path d="M16.665 0C17.5855 2.14748e-05 18.3317 0.746205 18.3317 1.66667V17.6904L21.3997 14.9967C22.0915 14.3895 23.146 14.458 23.7533 15.1497C24.3605 15.8415 24.292 16.896 23.6003 17.5033L17.7653 22.6253C17.1361 23.1776 16.1938 23.1762 15.5648 22.6237L9.73307 17.5016C9.04196 16.8941 8.9744 15.8411 9.58171 15.1497C10.1892 14.4586 11.2422 14.3911 11.9336 14.9984L14.9984 17.6888V3.43913C8.42235 4.25941 3.33333 9.8667 3.33333 16.6667C3.33333 24.0312 9.30214 30 16.6667 30C24.0312 30 30 24.0312 30 16.6667C30 11.4403 26.9837 6.92223 22.5895 4.7347C21.7655 4.3245 21.429 3.32402 21.8392 2.5C22.2494 1.67633 23.2501 1.34147 24.0739 1.7513C29.5496 4.47715 33.3333 10.1198 33.3333 16.6667C33.3333 25.8721 25.8721 33.3333 16.6667 33.3333C7.46119 33.3333 0 25.8721 0 16.6667C0 7.46131 7.46111 0 16.665 0Z" />
    </Icon>
  );
};

export default ExtendIcon;
